import React, { Fragment, useContext, useEffect } from "react";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import { NumericFormat } from "react-number-format";

import { ServiciosContext } from "../../../context/ServiciosContext";
import { ConfiguracionContext } from "../../../context/ConfiguracionContext";
import { Calendar } from "primereact/calendar";
import { locale, addLocale } from "primereact/api";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "../../../assets/css/DialogDemo.css";

addLocale("es", {
  firstDayOfWeek: 1,
  dayNames: [
    "domingo",
    "lunes",
    "martes",
    "miércoles",
    "jueves",
    "viernes",
    "sábado",
  ],
  dayNamesShort: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
  dayNamesMin: ["D", "L", "M", "X", "J", "V", "S"],
  monthNames: [
    "enero",
    "febrero",
    "marzo",
    "abril",
    "mayo",
    "junio",
    "julio",
    "agosto",
    "septiembre",
    "octubre",
    "noviembre",
    "diciembre",
  ],
  monthNamesShort: [
    "ene",
    "feb",
    "mar",
    "abr",
    "may",
    "jun",
    "jul",
    "ago",
    "sep",
    "oct",
    "nov",
    "dic",
  ],
  today: "Hoy",
  clear: "Limpiar",
});
locale("es");

export default function TomaNaranja(props) {
  const minDate = new Date();

  const { tomaNaranja, guardarTomaNaranja } = useContext(ServiciosContext);
  const { obtenerTiposMoviles } = useContext(ConfiguracionContext);

  useEffect(() => {
    obtenerTiposMoviles();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Leer tecla y foco (Enter avanza, Esc retrocede).
  const ORDEN = [
    "llegada",
    "duracion",
    "cantidadMoviles",
    "dotacion",
    "tipoEvento",
    "responsable",
    "contacto",
    "pedido",
    "telefonoNaranja",
    "cantidadPersonas",
    "descripcion",
  ];

  function handleEnter(event) {
    const i = ORDEN.indexOf(event.target.id);
    if (i === -1) return;
    let destino = null;
    if (event.keyCode === 13 && i < ORDEN.length - 1) destino = ORDEN[i + 1];
    if (event.keyCode === 27 && i > 0) destino = ORDEN[i - 1];
    if (destino) {
      const campo = document.getElementById(destino);
      if (campo) campo.focus();
    }
  }

  return (
    <Fragment>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography
            variant="caption"
            color="text.secondary"
            component="div"
            sx={{ mb: 0.5 }}
          >
            Llegada *
          </Typography>
          <Calendar
            id="llegada"
            dateFormat="dd/mm/yy"
            selectionMode="multiple"
            locale="es"
            minDate={minDate}
            value={tomaNaranja ? tomaNaranja.llegada : null}
            baseZIndex={5001}
            appendTo={typeof document !== "undefined" ? document.body : null}
            touchUI
            showTime
            required
            showButtonBar
            placeholder="dd/mm/aaaa hh:mm"
            style={{ width: "100%" }}
            inputStyle={{ width: "100%" }}
            onKeyDown={handleEnter}
            onChange={(e) =>
              guardarTomaNaranja({ ...tomaNaranja, llegada: e.value })
            }
          />
        </Grid>

        <Grid item xs={12} sm={8}>
          <TextField
            id="duracion"
            label="Duración"
            fullWidth
            size="small"
            InputLabelProps={{ shrink: true }}
            value={tomaNaranja ? tomaNaranja.duracion : null}
            required
            onKeyDown={handleEnter}
            onChange={(e) =>
              guardarTomaNaranja({ ...tomaNaranja, duracion: e.target.value })
            }
          />
        </Grid>

        <Grid item xs={12} sm={4}>
          <NumericFormat
            {...props}
            id="cantidadMoviles"
            label="Cantidad de móviles"
            customInput={TextField}
            format="###"
            type="numeric"
            fullWidth
            size="small"
            InputLabelProps={{ shrink: true }}
            value={tomaNaranja ? tomaNaranja.cantidadMoviles : null}
            required
            onKeyDown={handleEnter}
            onChange={(e) =>
              guardarTomaNaranja({
                ...tomaNaranja,
                cantidadMoviles: e.target.value,
              })
            }
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            id="dotacion"
            label="Dotación"
            fullWidth
            size="small"
            InputLabelProps={{ shrink: true }}
            value={tomaNaranja ? tomaNaranja.dotacion : null}
            onKeyDown={handleEnter}
            onChange={(e) =>
              guardarTomaNaranja({ ...tomaNaranja, dotacion: e.target.value })
            }
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            id="tipoEvento"
            label="Tipo de evento"
            fullWidth
            size="small"
            InputLabelProps={{ shrink: true }}
            value={tomaNaranja ? tomaNaranja.tipoEvento : null}
            onKeyDown={handleEnter}
            onChange={(e) =>
              guardarTomaNaranja({ ...tomaNaranja, tipoEvento: e.target.value })
            }
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            id="responsable"
            label="Responsable"
            fullWidth
            size="small"
            InputLabelProps={{ shrink: true }}
            value={tomaNaranja ? tomaNaranja.responsable : null}
            onKeyDown={handleEnter}
            onChange={(e) =>
              guardarTomaNaranja({ ...tomaNaranja, responsable: e.target.value })
            }
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            id="contacto"
            label="Contacto"
            fullWidth
            size="small"
            InputLabelProps={{ shrink: true }}
            value={tomaNaranja ? tomaNaranja.contacto : null}
            onKeyDown={handleEnter}
            onChange={(e) =>
              guardarTomaNaranja({ ...tomaNaranja, contacto: e.target.value })
            }
          />
        </Grid>

        <Grid item xs={12} sm={4}>
          <TextField
            id="pedido"
            label="Pedido"
            type="date"
            fullWidth
            size="small"
            onKeyDown={handleEnter}
            value={tomaNaranja ? tomaNaranja.pedido : null}
            required
            InputLabelProps={{ shrink: true }}
            onChange={(e) =>
              guardarTomaNaranja({ ...tomaNaranja, pedido: e.target.value })
            }
          />
        </Grid>

        <Grid item xs={12} sm={4}>
          <TextField
            id="telefonoNaranja"
            label="Teléfono"
            fullWidth
            size="small"
            InputLabelProps={{ shrink: true }}
            value={tomaNaranja ? tomaNaranja.telefono : null}
            onKeyDown={handleEnter}
            onChange={(e) =>
              guardarTomaNaranja({ ...tomaNaranja, telefono: e.target.value })
            }
          />
        </Grid>

        <Grid item xs={12} sm={4}>
          <NumericFormat
            {...props}
            id="cantidadPersonas"
            label="Cantidad de personas"
            customInput={TextField}
            type="numeric"
            fullWidth
            size="small"
            InputLabelProps={{ shrink: true }}
            value={tomaNaranja ? tomaNaranja.cantidadPersonas : null}
            onKeyDown={handleEnter}
            onChange={(e) =>
              guardarTomaNaranja({
                ...tomaNaranja,
                cantidadPersonas: e.target.value,
              })
            }
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            id="descripcion"
            label="Descripción"
            fullWidth
            multiline
            minRows={2}
            size="small"
            InputLabelProps={{ shrink: true }}
            value={tomaNaranja ? tomaNaranja.descripcion : null}
            onKeyDown={handleEnter}
            onChange={(e) =>
              guardarTomaNaranja({ ...tomaNaranja, descripcion: e.target.value })
            }
          />
        </Grid>
      </Grid>
    </Fragment>
  );
}
